var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MGPOptional } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Debug } from '../../utils/Debug';
import { SixMove } from './SixMove';
let SixMoveGenerator = class SixMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const legalLandings = this.rules.getLegalLandings(node.gameState);
        const totalDroppablePieces = 2 * config.piecesPerPlayer;
        if (node.gameState.turn < totalDroppablePieces) {
            return this.getListDrops(legalLandings);
        }
        else {
            return this.getTranslations(node.gameState, legalLandings);
        }
    }
    getTranslations(state, legalLandings) {
        const allPieces = state.getPieces().reverse();
        const currentPlayer = state.getCurrentPlayer();
        const playerPieces = allPieces.get(currentPlayer).get();
        return this.getTranslationsFrom(state, playerPieces, legalLandings);
    }
    getTranslationsFrom(state, starts, landings) {
        const translations = [];
        for (const start of starts) {
            for (const landing of landings) {
                const move = SixMove.ofTranslation(start, landing);
                if (state.isCoordConnected(landing, MGPOptional.of(start))) {
                    const stateAfterMove = state.movePiece(move);
                    const groupsAfterMove = stateAfterMove.getGroups();
                    if (this.rules.isSplit(groupsAfterMove)) {
                        const largestGroups = this.rules.getLargestGroups(groupsAfterMove);
                        if (largestGroups.size() === 1) {
                            translations.push(SixMove.ofTranslation(start, landing));
                        }
                        else {
                            for (const group of largestGroups) {
                                const subGroup = group.getAnyElement().get();
                                const cut = SixMove.ofCut(start, landing, subGroup);
                                translations.push(cut);
                            }
                        }
                    }
                    else {
                        translations.push(move);
                    }
                }
            }
        }
        return translations;
    }
    getListDrops(legalLandings) {
        const drops = [];
        for (const landing of legalLandings) {
            const drop = SixMove.ofDrop(landing);
            drops.push(drop);
        }
        return drops;
    }
};
SixMoveGenerator = __decorate([
    Debug.log
], SixMoveGenerator);
export { SixMoveGenerator };
